import { Pipe, PipeTransform } from '@angular/core';
import { OrderReturnReason } from '../../models';

@Pipe({
  standalone: false,
  name: 'orderReturnReason',
})
export class OrderReturnReasonPipe implements PipeTransform {
  transform(reason: OrderReturnReason) {
    switch (reason) {
      case OrderReturnReason.PART_WARRANTY:
        return 'Garantia da Peça';
      case OrderReturnReason.PURCHASE_REGRET:
        return 'Arrependimento da Compra';
      case OrderReturnReason.APPLICATION_ERROR:
        return 'Erro de Aplicação';
      case OrderReturnReason.LATE_DELIVERY:
        return 'Entrega atrasada ou incompleta';
      case OrderReturnReason.STOCK_BREAK:
        return 'Quebra de Estoque';
      case OrderReturnReason.PRODUCT_PROBLEM:
        return 'Produto com problema';
      case OrderReturnReason.CHANGED_MIND:
        return 'Mudei de ideia';
      case OrderReturnReason.CANCELED_ORDER:
        return 'Cancelamento de Pedido';
      case OrderReturnReason.OTHERS:
        return 'Outros';
      default:
        return reason;
    }
  }
}
